import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { inject } from '@angular/core';
import alertify from 'alertifyjs';


export const roleGuardsGuard: CanActivateFn = (route) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  
  const requiredPermissions = route.data['permissions'] as string[];
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }
  if (authService.hasPermissions(requiredPermissions)) {
    return true;
  }
  alertify.error("User does not have the required permission(s)");
  return router.parseUrl('/login');
};